export type UserRevokedAction = {
	type: 'USER_REVOKED';
};

export default (): UserRevokedAction => ({
	type: 'USER_REVOKED',
});
